module.exports = __webpack_public_path__ + "img/badges - grayscale.84fb55b0.svg";